import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Yo, I'm Matthew! Welcome!`}</h1>
    <p>{`This is my "bio" of sorts, seeing as the one on AOTY is capped to 500 characters. Check it out if you'd like!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      